import React, { useState, useEffect } from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import { getApi } from '~/util/api'
import { Button, Card, Typography } from '~/components/_atoms'
import { Stack } from '~/components/_layouts'
import Spinner from '~/components/shared/Spinner'

export function RecommendedBoardsCard({ className }) {
  const { t } = useTranslation()

  const [isLoading, setIsLoading] = useState(false)
  const [recommendedBoards, setRecommendedBoards] = useState([])

  useEffect(() => {
    setIsLoading(true)
    getApi()
      .get('/recommended_boards')
      .then((response) => {
        if (response.status == 200) {
          setRecommendedBoards(response.data)
          return
        } else {
          throw new Error('json request failed')
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
      .catch((error) => {
        console.log('json request failed', error)
      })
  }, [setRecommendedBoards])

  return (
    <Card
      className={className}
      title={t('recommended_boards_card.title')}
      actions={
        <div className="yns-stack flex flex-row flex-wrap items-center gap-2 ">
          <Button
            variant="ghost"
            size="sm"
            href="/job-search/boards"
            className="ga-trackable w-full @sm:w-auto"
          >
            {t('recommended_boards_card.view_action')}
          </Button>
        </div>
      }
    >
      <Stack spacing={3}>
        <Typography>{t('recommended_boards_card.description')}</Typography>
        {isLoading ? (
          <div className="flex items-center justify-center">
            <Spinner show className="h-9 w-9" />
          </div>
        ) : (
          <div className="m-auto grid w-full grid-cols-1 gap-4 pt-2 sm:grid-cols-3">
            {recommendedBoards.map((board, index) => (
              <div key={index} className="flex items-center justify-center">
                {board.logo ? (
                  <img
                    src={board.logo}
                    alt={board.title}
                    title={board.title}
                    className="h-12 w-12 rounded-sm object-cover"
                  />
                ) : (
                  <div className="flex h-12 w-12 items-center justify-center rounded-sm bg-gray-200">
                    {board.title[0].toUpperCase()}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </Stack>
    </Card>
  )
}
